var _path, _path2, _rect, _path3, _path4, _path5, _rect2, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconWarehouse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6983 9H29.4065L40.4999 15.656H4.36719L15.6983 9Z",
    fill: "#E5813B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.4999 15.6553H4.36719V36.4157H40.4999V15.6553ZM32.1009 18.9828H13.4006V34.0381H32.1009V18.9828ZM33.0513 18.9831H39.0734V20.5678H33.0513V18.9831ZM39.0735 20.8855H33.0514V22.4702H39.0735V20.8855ZM33.0514 22.7865H39.0735V24.3713H33.0514V22.7865ZM39.0735 24.6881H33.0514V26.2728H39.0735V24.6881ZM33.0514 26.59H39.0735V28.1748H33.0514V26.59ZM39.0735 28.4924H33.0514V30.0772H39.0735V28.4924ZM33.0514 30.3935H39.0735V31.9782H33.0514V30.3935ZM39.0735 32.2959H33.0514V33.8806H39.0735V32.2959ZM6.26866 19.1429H12.2908V20.7277H6.26866V19.1429ZM12.2909 21.0445H6.26875V22.6293H12.2909V21.0445ZM6.26875 22.9456H12.2909V24.5303H6.26875V22.9456ZM12.2909 24.8484H6.26875V26.4332H12.2909V24.8484ZM6.26875 26.7499H12.2909V28.3347H6.26875V26.7499ZM12.2909 28.6514H6.26875V30.2362H12.2909V28.6514ZM6.26875 30.5534H12.2909V32.1381H6.26875V30.5534ZM12.2909 32.4549H6.26875V34.0397H12.2909V32.4549Z",
    fill: "#E43F36"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.0738,
    y: 27.1685,
    width: 6.25983,
    height: 7.2107,
    fill: "#E0B063",
    stroke: "black",
    strokeWidth: 0.0792384
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0449 27.3672V34.1817",
    stroke: "black",
    strokeWidth: 0.0316954
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3516 29.4277H19.9775",
    stroke: "black",
    strokeWidth: 0.0316954
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3516 31.9629H19.9775",
    stroke: "black",
    strokeWidth: 0.0316954
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 25.484,
    y: 29.5465,
    width: 6.10136,
    height: 4.83354,
    fill: "#E0B063",
    stroke: "black",
    strokeWidth: 0.0792384
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4561 29.9814V34.0226",
    stroke: "black",
    strokeWidth: 0.0316954
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7617 31.9629H31.3876",
    stroke: "black",
    strokeWidth: 0.0316954
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarehouse);
export default __webpack_public_path__ + "static/media/icon-warehouse.7d337124eb7a2f748e69c257144c6af4.svg";
export { ForwardRef as ReactComponent };